import EnvImport from '../../../../env.json';

angular
    .module('festzelt-os.components')
    .constant('Env', EnvImport);



// WEBPACK FOOTER //
// ./src/app/components/constants/env.js